export interface ChartData {
  name: string;
  value: number;
  extra?: Record<string, unknown>;
}

export interface NormalizedChartData {
  value: number;
}

export const ChartColors = {
  SeaGreen: '#2E8B57',
  Orange: '#FFA500',
  RedOrange: '#E34234',
  Red: '#FF0000',
  GoogleGreen: '#33a852',
  GoogleYellow: '#FFEB3B',
  OrangeYellow: '#f4ad42',
  GoogleRed: '#ea4435',
  GoogleBlue: '#4285F4',
  Purple: '#9370DB',
  Gray: '#808080',
  AquaBlue: '#60a8d0',
};

export enum ChartType {
  DEVICE_INACTIVITY = 'DEVICE_INACTIVITY',
  AUTO_UPDATE_EXPIRY = 'AUTO_UPDATE_EXPIRY',
  OS_VERSION_STATE = 'OS_VERSION_STATE',
  STORAGE_USAGE = 'STORAGE_USAGE',
  BATTERY_HEALTH = 'BATTERY_HEALTH',
}

export enum VersionInfo {
  LATEST_OS = 'Latest OS',
  ONE_OS_BEHIND = '1 OS Version Behind',
  TWO_OS_BEHIND = '2 OS Versions Behind',
  THREE_PLUS_OS_BEHIND = '3+ OS Versions Behind',
}

export interface ChartColorScheme {
  domain: string[];
  name: string;
  selectable: boolean;
  group: string;
}

export interface ChartCustomColor {
  name: string;
  value: string;
}

export interface ChartSelectEvent {
  name?: string;
  value?: number;
  series?: string;
}

export interface ChartActionTrigger {
  chartType: string;
  clickedValue?: string;
  targetFilterBar?: string;
}

export type LabelFormattingFunction = (value: number | string) => string;
export type TooltipTextFunction = (data: ChartData) => string;
